const { PageContextProvider } = require('./src/context/PageContext')

const transitionDelay = 50

exports.shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash) {
    const element = document.querySelector(location.hash)
    if (element) {
      window.setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }, transitionDelay)
    }
    return false
  }
  if (location.action === 'PUSH' && location.hash === '') {
    window.setTimeout(() => window.scrollTo(0, 0), transitionDelay)
  }
  return false
}

exports.wrapPageElement = ({ element, props }) => {
  return (
    <PageContextProvider pageContext={props.pageContext}>
      {element}
    </PageContextProvider>
  )
}
